import styled from 'styled-components';

const HeroStyle = styled.div`
	--marginT: var(--sp13x);
	--titleMarginT: var(--sp5x);
	--titleMarginB: var(--sp9x);
	--imgMarginB: var(--sp10x);
	--borderRadius: var(--sp4x);
	--imageSize: 39.3%;

	margin-top: var(--marginT);
	color: var(--green1000);

	.share-inner-wrapper {
		a {
			transform: scale(0);
		}
	}

	.title-text {
		margin: var(--titleMarginT) 0 var(--titleMarginB);
	}

	.image-wrapper {
		margin-bottom: var(--imgMarginB);

		.image-cont {
			--proportion: var(--imageSize);

			img {
				border-radius: var(--borderRadius);
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--marginT: var(--sp10x);
		--titleMarginB: var(--sp8x);
		--borderRadius: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--marginT: var(--sp8x);
		--titleMarginT: var(--sp4x);
		--titleMarginB: var(--sp7x);
		--imgMarginB: var(--sp8x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--marginT: var(--sp7x);
		--titleMarginB: var(--sp6x);
		--borderRadius: var(--sp2x);
		--imgMarginB: var(--sp7x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--marginT: var(--sp6x);
		--titleMarginB: var(--sp5x);
		--imgMarginB: var(--sp6x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--marginT: var(--sp5x);
		--titleMarginT: var(--sp3x);
		--titleMarginB: var(--sp4x);
		--imgMarginB: var(--sp4x);
		--borderRadius: var(--sp1-5x);
		--imageSize: 49.7%;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--marginT: var(--sp4x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		.shared-top {
			display: none;
		}
	}
`;
export default HeroStyle;
